import { Skeleton } from "@ui/shad"
import { cn } from "@ui/utils"

export default function PeekViewSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn("w-screen max-w-sm space-y-2", className)}>
      <Skeleton className="h-6 w-full" />
      <div className="flex w-full items-center gap-2">
        <Skeleton className="size-5 flex-none" />
        <Skeleton className="h-5 grow" />
      </div>
      <div className="flex w-full items-center gap-2">
        <Skeleton className="size-5 flex-none" />
        <Skeleton className="h-5 grow" />
      </div>
      <div className="flex w-full items-start gap-2">
        <Skeleton className="size-5 flex-none" />
        <div className="grow space-y-1">
          <Skeleton className="h-5 w-full" />
          <Skeleton className="h-5 w-full" />
        </div>
      </div>
    </div>
  )
}
